import { FiTrash2 } from "react-icons/fi";

interface DeleteClipButtonProps {
  deleting: boolean;
  placement: "card" | "modal";
  onDelete: () => void;
}

export function DeleteClipButton({ deleting, placement, onDelete }: DeleteClipButtonProps) {
  return (
    <button
      type="button"
      className={`clip-delete-button clip-delete-${placement}`}
      onClick={onDelete}
      disabled={deleting}
      aria-label={deleting ? "Deleting clip" : "Delete clip"}
      title="Delete clip"
    >
      {deleting ? <span className="clip-delete-spinner" aria-hidden="true" /> : <FiTrash2 aria-hidden="true" />}
      {placement === "modal" && <span>{deleting ? "Deleting…" : "Delete"}</span>}
    </button>
  );
}
